<template>
  <div>
    <empty-card
      :table="true"
      :title="title"
    >
      <template slot="title">
        <b-button
          size="md"
          variant="dark"
          class="mx-md-1"
          @click="$router.push({name:'owner:posts'})"
        >
          {{ $t('poster.add-post') }}
        </b-button>
      </template>
      <ok-table
        ref="datatable"
        :config="config"
      >
        <template
          slot="image-column"
          slot-scope="{props}"
        >
          <img
            :src="props.row.picture"
            width="50"
            height="50"
          >
        </template>
        <template
          slot="post-column"
          slot-scope="{props}"
        >
          <a
            v-if="props.row.message"
            v-b-tooltip.html.hover.bottom="props.row.full_message"
            :href="props.row.link"
            target="_blank"
          >
            {{ props.row.message }}
          </a>
          <span v-else> - </span>
        </template>
        <template
          slot="actions-column"
          slot-scope="{props}"
        >

          <b-button
            :variant="props.row.enabled?'primary':'success'"
            size="sm"
            class="cursor-pointer"
            style="margin: 0 5px"
            @click="goReply(props.row)"
          >
            <span v-if="props.row.enabled">{{ $t('reply.edit') }}</span>
            <span v-else>{{ $t('reply.enable') }}</span>
          </b-button>
          <b-button
            v-b-tooltip.html.hover.bottom="{title: 'حذف'}"
            variant="danger"
            size="sm"
            class="cursor-pointer btn-icon  text-body"
            style="margin: 0 5px"
            @click="handleDelete(props.row)"
          >
            <FeatherIcon icon="TrashIcon" />
          </b-button>
        </template>
      </ok-table>
    </empty-card>
  </div>
</template>

<script>
import { BButton, VBTooltip } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import EmptyCard from '@/@bya3/components/cards/EmptyCard'
import OkTable from '@/@bya3/components/tables/ok-table/OkTable'
import FbPosterApi from '@/api/poster'
import PostsTableConfig from './config/scheduled-fb-posts-table-config'

export default {
  components: {
    EmptyCard,
    OkTable,
    BButton,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      config: PostsTableConfig,
    }
  },
  computed: {
    ...mapGetters({
      currentPageId: 'pages/currentPageId',
      currentPage: 'pages/currentPage',
    }),
    title() {
      const tr = this.isSchedule ? 'schedule-posts-page-title' : 'posts-page-title'
      return this.$t(`reply.${tr}`, { page: this.currentPage.name })
    },
  },
  watch: {
    currentPageId() {
      this.refreshTable()
    },
  },
  methods: {
    refreshTable() {
      this.$refs.datatable.loadItems()
    },
    goReply(row) {
      this.$router.push({ name: row.enabled ? 'owner:reply-edit' : 'owner:reply', params: { id: row.id } })
    },
    handleDelete(row) {
      this.$okConfirm(this.$t('poster.delete-post-message'), {
        preConfirm: () => FbPosterApi.deletePostFromFacebook(this.currentPageId, row.id)
          .then(response => {
            this.$notifySuccess(response.message)
            this.refreshTable()
          })
          .catch(e => this.$notifyError(e)),
      })
    },
  },
}
</script>
